module.exports = __webpack_public_path__ + "img/ruler-vertical.2503e2bf.svg";